import DataHelper from './data-helper.js';

export default class OrderableHelperSpreadsheet {
  constructor(parent) {
    this.parent = parent;
  }

  init() { }
}